import type { ReactNode } from 'react';

import { useWorkspacePlan } from '@/modules/billing/hooks/useWorkspacePlan';
import {
  lacksFeature,
  type PlanFeature,
} from '@/modules/billing/workspacePlan';

interface FreePlanGateProps {
  upgrade: ReactNode;
  children?: ReactNode;
  /** Gate on what the plan includes instead of on the Free plan itself. */
  requires?: PlanFeature;
}

/** Waits for billing before choosing the upgrade or regular UI. */
export function FreePlanGate({
  upgrade,
  children,
  requires,
}: FreePlanGateProps) {
  const workspacePlan = useWorkspacePlan();
  // Preserve the no-flash behavior while the SDK chunk or subscription loads.
  // Lookup failures finish loading, so these presentation gates do not wait forever.
  if (workspacePlan.isLoading) return null;

  return lacksFeature(workspacePlan, requires) ? upgrade : children;
}
